import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-toolbar',
  templateUrl: './skeleton-toolbar.component.html',
  styleUrls: ['./skeleton-toolbar.component.scss'],
})
export class SkeletonToolbarComponent {}
